import QuizEditBlock, { QuizEditBlockProps } from './QuizEditBlock';
import withInteractor from './QuizEditBlock.interactor';
import withPresenter from './QuizEditBlock.presenter';

export type { QuizEditBlockProps };
export default withInteractor(withPresenter(QuizEditBlock));
